// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_chatMessageList__2s-Ww {
  height: calc(100% - 75px);
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM {
  display: flex;
  flex-direction: column;
  padding: 0 8px;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 64px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li:hover {
  background-color: rgba(234, 237, 239, 0.4);
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li.style_active__7rkTC {
  background-color: #eaedef !important;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userLeftBlock__DBlI9 {
  display: flex;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  overflow: hidden;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_topRow__MS7qQ {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_topRow__MS7qQ .style_contactName__DT6BU {
  text-align: start;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 8px;
  flex: 1 1;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_topRow__MS7qQ .style_time__ofmt7 {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #626d7a;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_bottomRow__q9kTr {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_bottomRow__q9kTr .style_leftText__MfHmB {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
  text-align: start;
  padding-right: 8px;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_bottomRow__q9kTr .style_leftText__MfHmB .style_hallName__JJv2z {
  font-size: 13px;
  font-weight: 600;
  line-height: 15px;
  color: #909399;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_bottomRow__q9kTr .style_leftText__MfHmB .style_message__KnUig {
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: #626d7a;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_bottomRow__q9kTr .style_counter__Q1TyY {
  color: #ffffff;
  background-color: #5f8fdf;
  border-radius: 16px;
}
.style_chatMessageList__2s-Ww .style_chatList__2PpbM li .style_userRightBlock__isdmg .style_bottomRow__q9kTr .style_counter__Q1TyY div {
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  padding: 0 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Contacts/ContactList/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AADN;AAGM;EACE,0CAAA;AADR;AAIM;EACE,oCAAA;AAFR;AAKM;EACE,aAAA;AAHR;AAMM;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;AAJR;AAMQ;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAJV;AAMU;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cC/CJ;EDgDI,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;AAJZ;AAOU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cC/CK;AD0CjB;AASQ;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAPV;AASU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAPZ;AASY;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCpEG;EDqEH,gBAAA;EACA,mBAAA;EACA,uBAAA;AAPd;AAUY;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cC/EG;EDgFH,gBAAA;EACA,mBAAA;EACA,uBAAA;AARd;AAYU;EACE,cCpGJ;EDqGI,yBC9FG;ED+FH,mBAAA;AAVZ;AAYY;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAVd","sourcesContent":["@import '../../../variables.scss';\n\n.chatMessageList {\n  height: calc(100% - 75px);\n\n  .chatList {\n    display: flex;\n    flex-direction: column;\n    padding: 0 8px;\n\n    li {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      height: 64px;\n      padding: 8px;\n      border-radius: 8px;\n      cursor: pointer;\n\n      &:hover {\n        background-color: rgba($gray-active, 0.4);\n      }\n\n      &.active {\n        background-color: $gray-active !important;\n      }\n\n      .userLeftBlock {\n        display: flex;\n      }\n\n      .userRightBlock {\n        display: flex;\n        flex: 1;\n        flex-direction: column;\n        overflow: hidden;\n\n        .topRow {\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n          overflow: hidden;\n\n          .contactName {\n            text-align: start;\n            font-size: 14px;\n            line-height: 20px;\n            font-weight: 600;\n            color: $black;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            padding-right: 8px;\n            flex: 1;\n          }\n\n          .time {\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 20px;\n            color: $text-color-700;\n          }\n        }\n\n        .bottomRow {\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n          overflow: hidden;\n\n          .leftText {\n            display: flex;\n            flex-direction: column;\n            flex: 1;\n            overflow: hidden;\n            text-align: start;\n            padding-right: 8px;\n\n            .hallName {\n              font-size: 13px;\n              font-weight: 600;\n              line-height: 15px;\n              color: $text-color-600;\n              overflow: hidden;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n            }\n\n            .message {\n              font-size: 12px;\n              font-weight: 400;\n              line-height: 15px;\n              color: $text-color-700;\n              overflow: hidden;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n            }\n          }\n\n          .counter {\n            color: $white;\n            background-color: $active-color;\n            border-radius: 16px;\n\n            div {\n              font-size: 12px;\n              font-weight: 500;\n              line-height: 22px;\n              padding: 0 8px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatMessageList": `style_chatMessageList__2s-Ww`,
	"chatList": `style_chatList__2PpbM`,
	"active": `style_active__7rkTC`,
	"userLeftBlock": `style_userLeftBlock__DBlI9`,
	"userRightBlock": `style_userRightBlock__isdmg`,
	"topRow": `style_topRow__MS7qQ`,
	"contactName": `style_contactName__DT6BU`,
	"time": `style_time__ofmt7`,
	"bottomRow": `style_bottomRow__q9kTr`,
	"leftText": `style_leftText__MfHmB`,
	"hallName": `style_hallName__JJv2z`,
	"message": `style_message__KnUig`,
	"counter": `style_counter__Q1TyY`
};
export default ___CSS_LOADER_EXPORT___;
